import { useEffect } from "react";

import useStore from "core/custom-hooks/useStore";
import { setSettings } from "core/store/actionCreators";

import * as Utils from "core/common/utils";
import { SETTINGS_STORAGE_KEY } from "core/common/constants/localstorage";

export default function useSettings() {
    const inStorage = !!sessionStorage.getItem(SETTINGS_STORAGE_KEY);

    const { dispatch, settingsRepository, state } = useStore();
    const { settings } = state;

    useEffect(() => {

        const load = () => {

            Utils.loadingWrapper(dispatch, async () => {

                const response = await settingsRepository.get();
                if (response) {
                    const { data } = response;

                    if (Utils.isSuccessfulRequest(dispatch, data, false)) {

                        const { data: responseItem } = data;

                        const stringified = JSON.stringify(responseItem);

                        sessionStorage.setItem(SETTINGS_STORAGE_KEY, stringified);

                        dispatch(setSettings(responseItem));

                        console.debug("Settings are stored and dispached");
                    }
                }   
            });
        }

        if (inStorage === false) {

            load();

        } else {

            const parsed = JSON.parse(sessionStorage.getItem(SETTINGS_STORAGE_KEY))

            dispatch(setSettings(parsed));

            console.debug("Settings dispached");
        }

        // eslint-disable-next-line 
    }, [inStorage])

    return {
        ready: !!settings
    };
}